import { useFeatureFlags } from 'hooks'
import LiveChat from '../../LiveChat'
import { Header } from '../Header'
import { Main } from '../Main'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const Layout = () => {
  const [isLiveChatEnabled] = useFeatureFlags(['LIVE_CHAT'])

  return (
    <>
      <Header />
      <Main />
      {isLiveChatEnabled && <LiveChat />}
    </>
  )
}

export { Layout }
